import { sync } from '@genesislcap/foundation-utils';
import { html, ref, repeat } from '@microsoft/fast-element';
import { returnBackIcon } from '../../../../styles';
import { GRAPH_PERIOD_TIME } from '../../../../utils';
import type { AnalyticsStepTwo } from './analytics-step-two';
import { VPPA_COLUMNS } from './column-config';

export const AnalyticsStepTwoTemplate = html<AnalyticsStepTwo>`
    <zero-card class="no-padding-card" class="container"> 
        <zero-card class="all-contracts-wrapper no-padding-card">
            <div class="page-menu">
                <zero-tabs class="horizontal" orientation="horizontal">
                    <zero-button slot="start" class="return-button" appearance="secondary" @click="${(
                      x
                    ) => x.returnToPreviousStep()}">${returnBackIcon('start')}</zero-button>
                    <span slot="start" class="tab-title">Drilldown</span>
                    <div slot="end" class="criteria-selection">
                        <div class="periodicity-control">
                            <label class="control-label">Time Period</label>
                            <zero-segmented-control
                                appearance="primary"
                                orientation="horizontal"
                                :disabled=${(x) => x.disableButtons}
                                :value="${sync((x) => x.timePeriod)}"
                            >
                                <zero-segmented-item value=${
                                  GRAPH_PERIOD_TIME.ONE_YEAR
                                } class="custom-segmented-item">
                                1Y
                                </zero-segmented-item>
                                <zero-segmented-item value=${
                                  GRAPH_PERIOD_TIME.THREE_YEAR
                                } class="custom-segmented-item">
                                3Y
                                </zero-segmented-item>
                                <zero-segmented-item value=${
                                  GRAPH_PERIOD_TIME.FIVE_YEAR
                                } class="custom-segmented-item">
                                5Y
                                </zero-segmented-item>
                                <zero-segmented-item value=${
                                  GRAPH_PERIOD_TIME.TEN_YEAR
                                } class="custom-segmented-item">
                                10Y
                                </zero-segmented-item>
                            </zero-segmented-control>
                        </div>
                        <zero-button appearance="primary" :disabled=${(x) =>
                          x.disableButtons} @click="${(x) =>
  x.proceedToSummary()}">Proceed to Summary</zero-button>
                    </div>
                </zero-tabs>

            </diV>
            <div class="scroll-wrapper">
                <div class="charts-container">
                    <div class="chart-wrapper" >
                        <drilldown-expected-settlement-graph class="auto-height" ${ref(
                          'expectedSettlementGraph'
                        )}></drilldown-expected-settlement-graph>
                    </div>
                    <div class="chart-wrapper">
                        <drilldown-floating-price-graph class="auto-height" ${ref(
                          'floatingPriceGraph'
                        )}></drilldown-floating-price-graph>
                    </div>
                    <div class="chart-wrapper">
                        <drilldown-implied-carbon-graph class="auto-height" ${ref(
                          'impliedCarbonGraph'
                        )}></drilldown-implied-carbon-graph>
                    </div>
                    <div class="chart-wrapper">
                        <drilldown-nodal-lme-graph 
                          class="auto-height" 
                          ${ref('nodalLmeGraph')}
                          :timePeriod="${(x) => x.timePeriod}"
                        ></drilldown-nodal-lme-graph>
                    </div>
                </div>
                <div class="drilldown-grid">
                    <zero-grid-pro
                        class="grid-styles analytics-project-drilldown"
                        only-template-col-defs
                        sideBar=""
                        ${ref('vppaDrilldownGrid')}
                    >
                        ${repeat(
                          (x) => VPPA_COLUMNS(x),
                          html`
                            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
                          `
                        )}
                    </zero-grid-pro>
                </div>
            </div>
        </zero-card>
    </div>
`;
